import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { NavLink as Link, useParams } from 'react-router-dom';

import { LanguageSelector } from '../i18n/languageSelector';
import { useCurrentUserContext } from '../../context/currentUser';
import { useCurrentWorldContext } from '../../context/currentWorld';
import { useNonWorldRoutes } from '../../routes';
import { useWorldsContext } from '../../context/worlds';
import { BaseLogo } from '../logo-styles/baseLogo';
import { useIsExternalUser } from './externalUser';

import { UserDropdown } from './userDropdown';
import { WhatsNew } from '../whatsNew/whatsNew';
import './greetings.css';

export type Props = {
  worldAware: boolean,
  children?: React.ReactNode,
  logoLink?: string
};

export const Greetings = (props: Props) => {
  const { children, worldAware } = props;
  const currentUser = useCurrentUserContext();
  const { worldId } = useParams<{ worldId: string }>();
  const linkToLanding = worldId ? `/${worldId}/` : `/`;
  const { isExternalUser } = useIsExternalUser(currentUser.email);
  const WorldNameContainer = () => {
    const { name } = useCurrentWorldContext();
    const routes = useNonWorldRoutes();
    const { worlds } = useWorldsContext();

    const worldTextWithIcon = <><i data-id="world-name-icon" className="world-name-icon fas fa-globe-americas faicon" />
      {name}
    </>;

    return (worlds.length !== 1 ?
      <Link data-id="link-to-world-selection" to={routes.worldSelection} className="world-link worldName oemHeaderBg">
        {worldTextWithIcon}
      </Link>
      : <div data-id="world-name" className="world-name worldName oemHeaderBg">
        {worldTextWithIcon}
      </div>);
  };

  return (
    <div>
      <Helmet>
        {isExternalUser && <script defer data-id="plausible-analytics" data-domain={window.location.hostname} src="https://plausible.io/js/plausible.hash.js"></script>}
      </Helmet>
      <div className="greetings-header" id="elemez-header" data-id='greetings-page-header'>
        <div className="greetings-left-container" data-id="left-container">
          <Link className="greetings-logo-container" to={props.logoLink || linkToLanding} data-id='brand-logo'>
            <BaseLogo className="greetings-logo" />
          </Link>
          {worldAware && <WorldNameContainer />}
        </div>
        <span className="greetings-dropdown" data-id="greetings-dropdown">
          {(currentUser.isAdministrator || currentUser.isManager) && worldAware && <WhatsNew/> }
          {worldAware && <LanguageSelector />}
          <UserDropdown worldAware={worldAware} />
        </span>
      </div>
      <div className="body">
        {children}
      </div>
    </div>
  );
};
